"use client";

import { IconLoader2, IconUser } from "@tabler/icons-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/Avatar";
import React, { useEffect, useState } from "react";
import { breakpoints } from "../../../helpers/window";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { useUserContext } from "../../../providers/UserProvider";
import { navIconButtonClass } from "./navIconButtonClass";
import { MainMenuContent } from "./user-menu/MainMenuContent";

export const UserMenu = () => {
  const { currentUserAll } = useUserContext();
  const user = currentUserAll.data?.me;
  const [opened, setOpened] = useState<boolean>(false);
  const { width } = useWindowSize();

  useEffect(() => {
    if (width && width < breakpoints.lg) {
      setOpened(false);
    }
  }, [width, setOpened]);

  const isLoggedIn = !!user;

  return (
    <DropdownMenu
      onOpenChange={(isOpen) => {
        setOpened(isOpen);
      }}
      modal={false}
      open={opened}
    >
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          id="user-menu-trigger"
          data-testid="user-menu-trigger"
          className={navIconButtonClass}
        >
          {isLoggedIn ? (
            <Avatar>
              <AvatarImage
                src={user.avatarUrl ?? undefined}
                alt={user.displayName ?? "Avatar"}
              />
              <AvatarFallback className="text-gray-400">
                <IconLoader2 width={32} className="animate-spin" />
              </AvatarFallback>
            </Avatar>
          ) : (
            <IconUser width={32} />
          )}
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-[240px]">
        <MainMenuContent />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
